import { makeStyles } from '@material-ui/core';
import { stylesBase } from './base';

export const useStyles = makeStyles(theme => ({
  profile: {
    ...stylesBase(theme).profile,

    [theme.breakpoints.down('xs')]: {
      // color: theme.palette.common.white,
    },
  },
  userInfo: {
    width: '100%',
  },
  mobileLogout: {
    '& svg': {
      width: 30,
      height: 30,
      color: theme.palette.common.white,
    },
  },
  navHeader: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));
